// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 149) return "css/149-ed456e1c.css";
	if (chunkId === 581) return "css/581-e7df49a3.css";
	if (chunkId === 766) return "css/766-cc632839.css";
	// return url for filenames based on template
	return "css/" + ({"32":"givsum3","34":"application"}[chunkId] || chunkId) + "-" + {"32":"f5b17d3b","34":"aa56d168","128":"ac9d1121","525":"6c701203"}[chunkId] + ".css";
};